import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ProductForm from '../components/admin/ProductForm';
import ProductList from '../components/admin/ProductList';
import { getProducts, saveProducts } from '../utils/productStore';
import { useSeo } from '../utils/seo';
import '../styles/admin.scss';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState(getProducts);
  const [editingProduct, setEditingProduct] = useState(null);

  useSeo({
    title: 'Admin | Aavjo Industries',
    description: 'Aavjo Industries admin panel',
    path: '/admin-panel/dashboard',
    robots: 'noindex, nofollow',
  });

  useEffect(() => {
    saveProducts(products);
  }, [products]);

  const handleLogout = () => {
    localStorage.removeItem('adminLoggedIn');
    navigate('/admin-panel', { replace: true });
  };

  const addProduct = (product) => {
    setProducts((prev) => [{ ...product, id: Date.now() }, ...prev]);
  };

  const deleteProduct = (id) => {
    setProducts((prev) => prev.filter((p) => p.id !== id));
    if (editingProduct?.id === id) setEditingProduct(null);
  };

  const updateProduct = (updated) => {
    setProducts((prev) => prev.map((p) => (p.id === updated.id ? updated : p)));
    setEditingProduct(null);
  };

  const handleFormSubmit = (data) => {
    if (editingProduct) {
      updateProduct(data);
    } else {
      addProduct(data);
    }
  };

  return (
    <div className="admin-dashboard">
      <header className="admin-header">
        <div className="admin-brand">
          <span className="logo-icon">⚙️</span>
          <span>Admin Dashboard</span>
        </div>
        <div className="admin-logout" onClick={handleLogout}>
          <span>↩</span> Logout
        </div>
      </header>

      <main className="admin-main">
        <div className="admin-section">
          <h2>{editingProduct ? '✎ Edit Product' : '+ Add New Product'}</h2>
          <ProductForm
            onSubmit={handleFormSubmit}
            initialData={editingProduct}
            onCancel={() => setEditingProduct(null)}
          />
        </div>

        <div className="admin-section">
          <h2>
            Products{' '}
            <span className="count-badge">{products.length}</span>
          </h2>
          <ProductList
            products={products}
            onDelete={deleteProduct}
            onEdit={setEditingProduct}
          />
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;
